import React, { useEffect, useState, Fragment } from 'react'
import EmployeeTimesheetIndSc from './EmployeeTimeSheet.sc'
import { get_timesheet_of_user_by_user_id } from '../../../../api/Timesheet/read/user/get_timesheet_of_user_by_user_id'
import { useAuthContext } from '../../../../hooks'
import { useParams } from 'react-router-dom'
import { getOrgUsersProjects } from '../../../../api/project/getOrgUserProjects'
import EmployeeChartComponent from '../Charts/TimeSheetChart'

const EmployeeTImeSheet = () => {
  const auth = useAuthContext()
  const params = useParams()
  const [timeSheet, setTimeSheet] = useState<any>([])
  const [selectedDate, setSelectedDate] = useState('')
  const [projectId, setProjectId] = useState('')
  const [getProjects, SetProjects] = useState<any[]>([])
  useEffect(() => {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    const formattedDate = `${year}-${month}-${day}`
    setSelectedDate(formattedDate)
  }, [])
  const fetchTimeSheet = async () => {
    const res = await get_timesheet_of_user_by_user_id(
      auth?.userInfo?.orgs[0]?.id,
      params.employeeIdInd,
      "2023-11-20","2023-11-24"
    )
    setTimeSheet(res)
  }
  const handleDateChange = (date: any) => {
    setSelectedDate(date)
  }
  const handleProjectChange = (projectId: any) => {
    setProjectId(projectId)
  }
  const fetchOrguserProjects = async () => {
    await getOrgUsersProjects(auth?.userInfo?.orgs[0]?.id, params.employeeIdInd)
      .then((e: any) => {
        SetProjects(e)
      })
      .catch((e) => console.log(e))
  }
  useEffect(() => {
    fetchTimeSheet()
    fetchOrguserProjects()
  }, [])
  const filteredTimeSheet = timeSheet?.[0]?.timesheet.filter(
    (item: any) =>
      item.date === selectedDate ||
      (item.date === selectedDate && item.project_id === projectId) ||
      item.project_id === projectId,
  )
  const [duration, setDuration] = useState<any>([])
  useEffect(() => {
    const filteredTimeSheetWithTotalDuration = filteredTimeSheet?.map(
      (item: any) => {
        // Assuming duration is a string like "02h 30m"
        // Split the duration by space first, then remove 'h' and 'm' to get numbers
        const [hoursPart, minutesPart] = item.duration.split(' ')

        // Extract the numeric parts by removing 'h' from the hours part and 'm' from the minutes part
        const hours = parseInt(hoursPart.replace('h', ''), 10)
        const minutes = parseInt(minutesPart.replace('m', ''), 10)

        // Calculate total duration in minutes
        const totalDuration = hours * 60 + minutes

        // Return the item with the totalDuration property
        console.log(totalDuration, 'total')
        return {
          totalDuration, // Add the total duration to the object
        }
      },
    )

    console.log(filteredTimeSheetWithTotalDuration?.[0], 'durations')
    setDuration(filteredTimeSheetWithTotalDuration?.[0])
  }, [projectId, selectedDate])
  console.log(duration, 'duration')
  return (
    <EmployeeTimesheetIndSc>
      <div className="filter_option">
        <div>
          <select
            className="select-container"
            onChange={(e) => handleProjectChange(e.target.value)}
            style={{ padding: '0.5rem 1rem' }}
          >
            {getProjects?.map((data: any, idx: any) => {
              return (
                <Fragment key={idx}>
                  <option value={data?.ProjectId}>{data?.ProjectName}</option>
                </Fragment>
              )
            })}
          </select>
        </div>

        <div className="select-container">
          <input
            className="date-input"
            type="date"
            value={selectedDate}
            onChange={(e) => handleDateChange(e.target.value)}
          />
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Project Name</th>
            <th>Purpose</th>
            <th>Comment</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Duration</th>
            <th>Date</th>
            <th>Day</th>
          </tr>
        </thead>
        <tbody>
          {filteredTimeSheet?.map((data: any, idx: any) => {
            return (
              <Fragment key={idx}>
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{data.project_name}</td>
                  <td>{data.purpose}</td>
                  <td>{data.comment}</td>
                  <td>{data.start_time}</td>
                  <td>{data.end_time}</td>
                  <td>{data.duration}</td>
                  <td>{data.date}</td>
                  <td>{data.day}</td>
                </tr>
              </Fragment>
            )
          })}
        </tbody>
      </table>
    </EmployeeTimesheetIndSc>
  )
}

export default EmployeeTImeSheet
